import { IApp } from '../types/app';

export const loadApp = (): IApp => ({
    configuredExpanded: true,
    byodExpanded: true,
    templatesExpanded: true,
    webhookExpanded: true,
})



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/services/app.ts